export { default } from './TruncatedText';
